import React from 'react';
import { TeamMemberContainer } from './TeamMemberContainer';
import { MainMembersContainer } from './MainMembersContainer';
import { TeamItemContainer } from './TeamItemContainer';
import { t } from '../../i18n';
import { Team } from '../model/Team';

type TeamItemProps = {
  team: Team;
};
export const CooperationTeam = (props: TeamItemProps) => {
  return (
    <TeamItemContainer>
      <h3>{t('teams.cooperation.title')}</h3>
      <MainMembersContainer>
        {props.team.teamMembers.map((member, key) => (
          <TeamMemberContainer key={key} member={member} itemsPerRow={2} />
        ))}
      </MainMembersContainer>
    </TeamItemContainer>
  );
};
